import { lazy } from 'react'

export const ProgramSuite = lazy(() => import('./ProgramSuite'))
